export default "__VITE_ASSET__34GvKrGM__"